import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

export class UnmountBookingDetailAction extends BaseAction<void, void> {

    override async run(): Promise<void | null> {
        try {
            updateRecoilState("repeatedBookingAtom", {
                tripStatus: "",
                repeatBooking: "",
                direction: ""
            });
            updateRecoilState("bookingResponseAtom", null);
            updateRecoilState("bookingConfirmStatusAtom", "");
            updateRecoilState("upgradeOutboundOffersAtom", null);
            updateRecoilState("upgradeInboundOffersAtom", null);
        } catch (error) {
            console.error("Error in UnmountBookingDetailAction:", error);
        }
    }
}

// Create a singleton instance
export const unmountBookingDetailAction = new UnmountBookingDetailAction(); 